import { render } from "./DebtorFormLink.vue?vue&type=template&id=419d3123"
import script from "./DebtorFormLink.vue?vue&type=script&lang=js"
export * from "./DebtorFormLink.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__